

export async function fetchWithErrorLog(
    input: URL | RequestInfo,
    init: RequestInit | undefined
) {
    const res = await fetch(input, init);
    logZodErrors(res);
    return res;
}

async function logZodErrors(res: Response) {
    if (!res.ok) {
        try {
            const clonedRes = res.clone();
            const body = await clonedRes.json();

            const bodyAsArray = Array.isArray(body) ? body : [body];
            for (const { error } of bodyAsArray) {
                if (error?.json.code === -32600 && error?.json.message) {
                    console.error('Zod validation errors:', error.json.message);
                }
            }
        } catch (e) {
            console.error('Error parsing TRPC response:', e);
        }
    }
}